// CI/CD environment configs - this file is used across various pipeline stages
// environment variables are maintained in octopus
// https://octopus.com/docs/deployment-process/configuration-features/substitute-variables-in-files

export const environment = {
    production: true,
    name: ' prod',
    sentry: {
        enabled: 'true',
        dsn: 'https://004febf12cbeb72f5b7f7935572e6b38@o236113.ingest.us.sentry.io/4507538775015424',
        environment: 'prod',
        release: '1e3da20'
    }
};
